(() => {
  const form = document.querySelector('#search-form');
  const input = form?.querySelector('input[name="q"]');
  const results = form?.querySelector('[data-braap-search-assist]');
  if (!form || !input || !results) return;

  let timer;
  let controller;
  let activeIndex = -1;
  const displayText = (value) => String(value || '').replace(/100(?:-|\s)percent/gi, '100%');
  const wordList = (value) => String(value || '').normalize('NFKD').toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9%]+/g, ' ').trim().split(/\s+/).filter(Boolean);
  const aliases = { bars: ['handlebar', 'handlebars'], bar: ['handlebar'], tyre: ['tire'], tyres: ['tire', 'tires'], sxs: ['utv'], jetski: ['watercraft', 'pwc'], sled: ['snowmobile'], shield: ['faceshield', 'visor'], visor: ['shield', 'faceshield'], tee: ['shirt'], hoodie: ['sweatshirt'], boots: ['footwear'], quad: ['atv'], fourwheeler: ['atv'] };
  const near = (a, b) => {
    if (a === b) return true;
    if (Math.min(a.length, b.length) < 4 || Math.abs(a.length - b.length) > 1) return false;
    if (a.length === b.length) for (let index = 0; index < a.length - 1; index += 1) if (a.slice(0, index) === b.slice(0, index) && a[index] !== b[index] && a[index] === b[index + 1] && a[index + 1] === b[index] && a.slice(index + 2) === b.slice(index + 2)) return true;
    let left = 0, right = 0, changes = 0;
    while (left < a.length && right < b.length) {
      if (a[left] === b[right]) { left += 1; right += 1; continue; }
      if (++changes > 1) return false;
      if (a.length > b.length) left += 1;
      else if (b.length > a.length) right += 1;
      else { left += 1; right += 1; }
    }
    return changes + (left < a.length || right < b.length ? 1 : 0) <= 1;
  };
  const options = () => [...results.querySelectorAll('[role="option"]')];
  const activate = (index) => {
    const rows = options();
    if (!rows.length) return;
    activeIndex = (index + rows.length) % rows.length;
    rows.forEach((row, position) => row.setAttribute('aria-selected', String(position === activeIndex)));
    input.setAttribute('aria-activedescendant', rows[activeIndex].id);
    rows[activeIndex].scrollIntoView({ block: 'nearest' });
  };
  const close = () => {
    activeIndex = -1;
    results.hidden = true;
    results.replaceChildren();
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
  };
  const show = (products, term) => {
    results.replaceChildren();
    const heading = document.createElement('strong');
    heading.className = 'braap-search-assist__heading';
    heading.textContent = products.length ? 'Product matches' : 'Smart catalog search';
    const list = document.createElement('div');
    list.setAttribute('role', 'listbox');
    products.forEach((product, index) => {
      const link = document.createElement('a');
      link.href = product.url;
      link.className = 'braap-search-assist__item';
      link.setAttribute('role', 'option');
      link.id = `braap-search-option-${index}`;
      link.setAttribute('aria-selected', 'false');
      link.addEventListener('pointerenter', () => activate(index));
      if (product.image) {
        const image = document.createElement('img');
        image.src = product.image;
        image.alt = '';
        image.loading = 'lazy';
        link.append(image);
      }
      const copy = document.createElement('span');
      const vendor = document.createElement('small');
      const title = document.createElement('b');
      vendor.textContent = displayText(product.vendor || product.type || 'Product');
      title.textContent = displayText(product.title);
      copy.append(vendor, title);
      link.append(copy);
      list.append(link);
    });
    const all = document.createElement('a');
    all.className = 'braap-search-assist__all';
    all.href = `/search?type=product&options%5Bprefix%5D=last&q=${encodeURIComponent(term)}`;
    all.textContent = `See all results for “${term}” →`;
    all.textContent = products.length ? `See all results for “${term}” →` : `Search the full catalog for “${term}” →`;
    if (products.length) results.append(heading, list);
    results.append(all);
    results.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  };
  const search = async () => {
    const term = input.value.trim();
    if (term.length < 2) return close();
    controller?.abort();
    controller = new AbortController();
    const params = new URLSearchParams({
      q: term,
      'resources[type]': 'product',
      'resources[limit]': '10',
      'resources[limit_scope]': 'each',
      'resources[options][unavailable_products]': 'last',
      'resources[options][fields]': 'title,product_type,variants.title,variants.sku,variants.barcode,vendor'
    });
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}search/suggest.json?${params}`, { signal: controller.signal });
      if (!response.ok) throw new Error(`Search ${response.status}`);
      const payload = await response.json();
      if (input.value.trim() !== term) return;
      show(payload?.resources?.results?.products || [], term);
    } catch (error) {
      if (error.name !== 'AbortError') close();
    }
  };
  input.setAttribute('autocomplete', 'off');
  input.setAttribute('role', 'combobox');
  input.setAttribute('aria-autocomplete', 'list');
  input.setAttribute('aria-controls', results.id);
  input.setAttribute('aria-expanded', 'false');
  input.addEventListener('input', () => {
    activeIndex = -1;
    clearTimeout(timer);
    timer = setTimeout(search, 180);
  });
  input.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { close(); return; }
    if (results.hidden || !options().length) return;
    if (event.key === 'ArrowDown') { event.preventDefault(); activate(activeIndex + 1); }
    else if (event.key === 'ArrowUp') { event.preventDefault(); activate(activeIndex - 1); }
    else if (event.key === 'Enter' && activeIndex >= 0) {
      event.preventDefault(); options()[activeIndex]?.click();
    }
  });
  document.addEventListener('click', (event) => { if (!form.contains(event.target)) close(); });
})();
